module.exports = __webpack_public_path__ + "img/title1.e57f8bc4.jpg";